/*
 *  Module for installing (registering) the PWA service worker
 */
rs.module("layouts/serviceworker-installer",[],

    function () {

        // Initialize the module
        function initialize(rootPath) {

            // Register the PWA service worker
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.register(rootPath + "/serviceworker.js");
            }
            else {
                console.log("Unable to register the service worker.");
            }
        }

        /// the interface to the control
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);